// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import './utils/error-handler'
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vant from 'vant';
import '@/assets/css/toast.less';
// import "../static/iconfont/iconfont.css"
// import 'amfe-flexible';   //用于rem的适配
import './bin/rem';

import initRouter from './router/routerfilter';
import store from './store/store';
import MoListenIcon from './components/mo-listen-icon/index.vue'
// import Vant from 'vant';
// import 'vant/lib/index.less';
// import '@/assets/theme/index.css'
// import 'vant/lib/icon/local.css';//引用字体css

import Vconsole from 'vconsole';
import './utils/collect';

Vue.config.productionTip = false;
Vue.use(Vant);
// //使用瀑布流-插件
// import {VueMasonryPlugin} from 'vue-masonry';
// Vue.use(VueMasonryPlugin);

Vue.component('mo-listen-icon', MoListenIcon)

if(process.env.VUE_APP_ENV != 'production') {
 const vConsole = new Vconsole();
}
console.log('-main.ts- 适口区域宽高',document.documentElement.clientWidth,window.screen.availWidth)
console.log(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent))
console.log(navigator.userAgent);

Date.prototype.format = function(fmt:string) {
  var o = {
      "M+" : this.getMonth()+1,                 //月份
      "d+" : this.getDate(),                    //日
      "h+" : this.getHours(),                   //小时
      "m+" : this.getMinutes(),                 //分
      "s+" : this.getSeconds(),                 //秒
      "q+" : Math.floor((this.getMonth()+3)/3), //季度
      "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt)) {
      fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  }
  for(var k in o) {
      if(new RegExp("("+ k +")").test(fmt)){
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
      }
  }
  return fmt;
}
Vue.prototype.$sendMessage = function(type: string, data:any) {
    window.taroRawSdk.miniProgram.postMessage({
        type,
        data
    })
}
Vue.prototype.$bus = new Vue()
/* 
  说明：从url中获取关键词keyword参数
  keyWord: 关键词
 */
Vue.prototype.$getUrlKeyWord = function(keyWord: string) {
  let keyAfter = location.href.split(`${keyWord}=`)[1]
  let value = ''
  if (keyAfter) {
    value = keyAfter.split('&')[0]
  }
  return value
}

Vue.prototype.$navigateTo = function(data: {url: string}) {
    window.taroRawSdk.miniProgram.navigateTo(data)
}
Vue.prototype.$redirectTo = function(data: {url: string}) {
  window.taroRawSdk.miniProgram.redirectTo(data)
}
Vue.prototype.$navigateBack = function (){
  window.taroRawSdk.miniProgram.navigateBack();
}

Vue.directive('resetPage', {
    inserted (el) {
      document.body.addEventListener('focusin', () => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          // 软键盘收起的事件处理
          setTimeout(() => {
            document.getElementsByTagName('body')[0].className = 'inTouch'
          }, 100)
        }
      })
      document.body.addEventListener('focusout', () => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          // 软键盘收起的事件处理
          setTimeout(() => {
            const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
            window.scrollTo(0, Math.max(scrollHeight - 1, 0))
            // document.getElementsByTagName('body')[0].className = 'noTouch'
          }, 100)
        }
      })
    }
  })

initRouter(router, store);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
